(function () {
  'use strict';

  angular.module('sempraWebapp').component('rolloverDosing', {
    templateUrl:
      'app/facilityKarcherDetails/rolloverDosing/rolloverDosing.html',
    controller: rolloverDosing,
    bindings: {
      dosingList: '<',
      activation: '&',
      defaultVisibilityState: "<"
    },
    controllerAs: 'vm'
  });

  function rolloverDosing() {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.$onChanges = function () {};

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.updateDosing = function (dataToUpdate) {
      vm.activation({
        data: dataToUpdate
      });
    };
  }
})();
